<template>
    <div
        class="overflow-hidden rounded-xl border border-theme-border"
        :style="cssVars"
    >
        <div
            class="flex flex-col items-center gap-2 px-3 pt-4 pb-3"
            style="background: var(--color-stack-background)"
        >
            <img
                v-if="logoUrl"
                :src="logoUrl"
                alt=""
                class="h-12 w-12 flex-shrink-0 rounded-full object-cover"
            />
            <img
                v-else
                src="/img/logos/pet_logo.png"
                alt=""
                class="h-12 w-12 flex-shrink-0 rounded-full object-contain"
            />

            <span
                class="max-w-full truncate text-xs font-semibold"
                style="color: var(--color-stack-primary)"
            >
                {{ businessName }}
            </span>

            <div class="flex items-center gap-1.5">
                <social-icon
                    v-for="network in sampleNetworks"
                    :key="network"
                    :network="network"
                    :height="4"
                    :width="4"
                    style="color: var(--color-stack-emphasis)"
                />
            </div>

            <div
                v-if="displayMode === 'feed'"
                class="flex w-full flex-col gap-1 pt-1"
            >
                <span
                    v-for="n in 2"
                    :key="n"
                    class="h-3 w-full rounded-full"
                    style="background: var(--color-stack-emphasis)"
                ></span>
            </div>
            <div v-else class="grid w-full grid-cols-2 gap-1.5 pt-1">
                <div
                    v-for="(image, index) in sampleImages"
                    :key="index"
                    class="aspect-square overflow-hidden rounded-md bg-theme-hover"
                >
                    <img
                        :src="image"
                        alt=""
                        class="h-full w-full object-cover"
                    />
                </div>
            </div>
        </div>

        <!-- Franja neutra (no usa los colores del stack) para que los 4
        puntos sigan siendo visibles aunque alguno coincida con el fondo de
        arriba, ej. un fondo blanco sobre blanco. -->
        <div
            class="flex items-center justify-center gap-2 border-t border-theme-border bg-theme-card py-1.5"
        >
            <span
                v-for="swatch in swatches"
                :key="swatch.key"
                :title="swatch.label"
                class="h-3 w-3 rounded-full border border-theme-border"
                :style="{ background: swatch.color }"
            ></span>
        </div>
    </div>
</template>

<script>
import { buildStackTheme } from "@/common/lib/catalog-preview";
import { SAMPLE_PRODUCTS } from "@/common/lib/onboarding-preview-samples";

import SocialIcon from "@/components/icons/SocialIcon.vue";

const SAMPLE_NETWORKS = ["instagram", "facebook"];

export default {
    name: "PaletteCatalogThumbnail",

    components: { SocialIcon },

    props: {
        colors: {
            type: Object,
            required: true
        },
        businessName: {
            type: String,
            default: "Tu negocio"
        },
        logoUrl: {
            type: String,
            default: ""
        },
        // Miniatura reducida a proposito: un solo estilo, sin variar
        // productItemStyle ni el tipo de segment — solo importa transmitir
        // que hace cada color, no replicar el catalogo real.
        displayMode: {
            type: String,
            default: "catalog"
        }
    },

    data() {
        return {
            sampleNetworks: SAMPLE_NETWORKS
        };
    },

    computed: {
        theme() {
            return buildStackTheme(this.colors);
        },
        cssVars() {
            return this.theme.cssVars;
        },
        sampleImages() {
            return SAMPLE_PRODUCTS.slice(0, 2).map(
                (product) => product.references[0].images[0].url
            );
        },
        swatches() {
            const stack = this.theme.stack;
            return [
                { key: "primary", label: "Títulos", color: stack.primary },
                { key: "emphasis", label: "Énfasis", color: stack.emphasis },
                {
                    key: "background",
                    label: "Fondo",
                    color: stack.background
                },
                { key: "text", label: "Texto", color: stack.text }
            ];
        }
    }
};
</script>
